<template>
  <div
    class="sidebar row-block height-full"
    :class="{ active: active }"
    :style="{ height: minHeight + 'px' }"
    @mouseenter="e => active = true"
    @mouseleave="e => active = false"
  >
    <sidebarMain
      :active="active"
    ></sidebarMain>
  </div>
</template>

<script>
import sidebarMain from '../sidebar/main.vue'

export default {
  components: {
    sidebarMain
  },
  props: {
    minHeight: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      active: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/sidebar.vue